import React, { useState } from "react";
import { Box, Tooltip } from "@material-ui/core";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";

import { StyledGrid } from "components/simple";
import { color, fontSize, spacingDefaults } from "style/constants";

interface UserNameBadgeProps {
  code: string;
}

const UserNameBadge: React.FC<UserNameBadgeProps> = ({ code }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
  };

  return (
    <StyledGrid
      container
      alignItems="center"
      justifyContent="center"
      style={{ gap: spacingDefaults.xsmall }}
    >
      <Box
        display="flex"
        alignItems="center"
        border={`1px solid ${color.GRAY}`}
        borderRadius="25px"
        padding="0"
        overflow="hidden"
      >
        <span
          style={{
            color: color.BLUE,
            fontSize: fontSize.medium,
            padding: "8px 16px"
          }}
        >
          User name: <strong>{code}</strong>
        </span>

        <Box
          style={{
            width: "1px",
            alignSelf: "stretch",
            backgroundColor: color.GRAY
          }}
        />

        <Tooltip title={copied ? "Copied!" : "Copy"} arrow>
          <Box
            display="flex"
            alignItems="center"
            onClick={handleCopy}
            role="button"
            tabIndex={0}
            style={{
              gap: "6px",
              padding: "8px 16px",
              cursor: "pointer",
              color: color.BLUE
            }}
            aria-label="Copy server code"
          >
            <FileCopyOutlinedIcon fontSize="small" />
            <span style={{ fontWeight: 600, fontSize: fontSize.small }}>
              Copy
            </span>
          </Box>
        </Tooltip>
      </Box>
    </StyledGrid>
  );
};

export default UserNameBadge;
